import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import Components from './modules/components'
import Form from './modules/components/form'
import Register from './modules/views/register'
import Role from './modules/views/role'
import UserProfile from './modules/views/userProfile'
import User from './modules/views/user'
import Setting from './modules/views/setting'
import CustomMap from '@/store/modules/views/Map'
import Patient from './modules/views/patient'
import Sos from './modules/views/sos'
import Payment from './modules/views/payment'
import Center from './modules/views/center'
import PermissionState from '@/store/modules/views/permission'
import Job from '@/store/modules/views/job'
import MonthlyContract from '@/store/modules/views/monthlyContract'
import WorkingTime from '@/store/modules/views/workingTime'
import Caregiver from '@/store/modules/views/caregiver'
import PaymentHistory from '@/store/modules/views/paymentHistory'
import Schedule from '@/store/modules/views/schedule'
import Report from '@/store/modules/views/report'

Vue.use(Vuex)

export interface State {
  [key: string]: any
}

const store = new Vuex.Store({
  modules: {
    components: Components,
    form: Form,
    register: Register,
    role: Role,
    permission: PermissionState,
    userprofile: UserProfile,
    user: User,
    setting: Setting,
    map: CustomMap,
    patient: Patient,
    sos: Sos,
    payment: Payment,
    center: Center,
    job: Job,
    monthlyContract: MonthlyContract,
    workingTime: WorkingTime,
    caregiver: Caregiver,
    paymentHistory: PaymentHistory,
    schedule: Schedule,
    report: Report,
  },
})

export default store
